import React from 'react';
import NavigationMenuItem, {CounterType} from "../../../../menu-items/menu-item";
import {EVENT_BUS_USER_LAST_VISIT_NOTIFICATIONS} from "../../../../../../core/model2/user/bus";
import {BUS_APP_LAUNCH} from "../../../../../../core/gd/app-manager/@event"

export default class MainMenu_ItemNotifications extends React.Component<any,any> {

    constructor(props:any) {
        super(props);

        const totals = this.calculateTotals();

        this.state = {
            total: totals.notifications,
            totalNew: totals.notificationsNew,
            selected: false
        };
    }

    componentDidMount() {
        // gd.bus.subscribe('route', this, this.onRoute);
        gd.bus.subscribe(BUS_APP_LAUNCH, this, this.onLaunchApp);
        gd.session.counters.on('change add remove reset',this.onNotificationsChanged);


        gd.bus.subscribe(EVENT_BUS_USER_LAST_VISIT_NOTIFICATIONS, this, this.onNotificationsChanged)
    }

    componentDidUpdate() {
        this.updateSelection(window.location.pathname)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);
        gd.session.counters.off('change add remove reset',this.onNotificationsChanged);
    }

    onLaunchApp = (data:any) => {
        this.updateSelection(data.path)
    }

    updateSelection = (path:string) => {
        if (this.state.selected) {
            !path.includes('notifications') && this.setState({selected: false})
        } else {
            path.includes('notifications') && this.setState({selected: true})
        }
    }

    onNotificationsChanged = () => {
        const totals = this.calculateTotals();

        this.setState({
            total: totals.notifications,
            totalNew: totals.notificationsNew
        });
    };

    calculateTotals() {
        return {
            notifications       : gd.session.counters.getNotificationsCount(),
            notificationsNew    : 0
        }
    }

    render() {

        return <NavigationMenuItem name                 = "Notifications"
                                   selected             = {this.state.selected}
                                   icon                 = "i5-notification"
                                   url                  = "notifications"
                                   navigationSection    = {this.props.navigationSection}
                                   counter              = {this.state.total}
                                   counterStyle         = {CounterType.BLUE_BOX}
                                   moreMenuOptions      = {gd.user.personalViews.notifications.menuMoreOptions()}
                                   {...this.props} />
    }
}
